module.exports = __webpack_public_path__ + "media/images/features/modification/thumb-voices-1-ccefd04a07f0bd9383bd1b6224653b3b.png";